<template>
  <div class="perfiles-panel">
    <h3>Perfiles Estratégicos de Competidores</h3>
    <div class="perfiles-grid">
      <div v-for="perfil in perfiles" :key="perfil.tienda" class="perfil-card">
        <h4 class="store-name">{{ formatStoreName(perfil.tienda) }}</h4>
        <div class="rol" :class="getRolClass(perfil.rol_principal)">
          <span class="profile-tag">{{ perfil.rol_principal}}</span>
        </div>
        <p class="descripcion">{{ perfil.descripcion_estrategia }}</p>
      </div>
    </div>
    <p v-if="perfiles && perfiles.length > 0" class="footer-note">Análisis basado en el comportamiento de los últimos 90 días.</p>
    <p v-else class="footer-note">Calculando perfiles estratégicos...</p>
  </div>
</template>

<script setup>
defineProps({
  perfiles: Array
});

const formatStoreName = (name) => {
  if (!name) return '';
  return name.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
};

const getRolClass = (rol) => {
  if (rol === 'Líder Agresivo') return 'lider';
  if (rol === 'Seguidor Rápido') return 'seguidor';
  return 'observador';
};
</script>

<style scoped>
.perfiles-panel {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 3px;
  padding: 16px;
}
h3 {
  font-family: var(--font-mono);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
  color: var(--color-accent);
  text-transform: uppercase;
  margin: 0 0 14px;
}
.perfiles-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 10px;
}
.perfil-card {
  background: var(--color-surface-2);
  border: 1px solid var(--color-border);
  border-left: 3px solid var(--color-accent);
  border-radius: 2px;
  padding: 12px 14px;
  transition: all 0.15s;
}
.perfil-card:hover {
  border-color: var(--color-border-strong);
  background: var(--color-hover-bg);
}
.perfil-card .store-name {
  margin: 0 0 8px;
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: var(--color-text);
}
.rol {
  margin-bottom: 8px;
}
.profile-tag {
  display: inline-block;
  font-family: var(--font-mono);
  font-size: 9.5px;
  font-weight: 700;
  letter-spacing: 0.08em;
  padding: 3px 8px;
  border-radius: 2px;
  text-transform: uppercase;
  border: 1px solid var(--color-border-strong);
}
.rol.lider .profile-tag {
  color: var(--color-danger-text);
  background: var(--color-danger-bg);
  border-color: var(--color-danger);
}
.rol.seguidor .profile-tag {
  color: var(--color-accent);
  background: var(--color-accent-bg);
  border-color: var(--color-accent-border);
}
.rol.observador .profile-tag {
  color: var(--color-text-muted);
  background: var(--color-surface-3);
  border-color: var(--color-border-strong);
}
.descripcion {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  color: var(--color-text-muted);
  line-height: 1.5;
  margin: 0;
}
.footer-note {
  font-family: var(--font-mono);
  font-size: 10px;
  color: var(--color-text-faint);
  text-align: center;
  margin: 14px 0 0;
  font-style: italic;
  letter-spacing: 0.03em;
}
</style>
